export interface ICheckQrSessionRequest {
	bb_uuid: string;
	qrs_id: string;
}

export const QR_SESSION_STATUS = {
	OPEN: "OPEN",
	CLOSE: "CLOSE",
} as const;

export type QrSessionStatus = (typeof QR_SESSION_STATUS)[keyof typeof QR_SESSION_STATUS];

export interface ICheckQrSessionAttributes {
	bb_id: number;
	bb_uuid: string;
	created_at: string;
	created_by: string;
	order_until: string;
	pax: number;
	status: string;
	table: string;
}

export interface ICheckQrSessionResponse {
	data: {
		type: string;
		id: string;
		attributes: ICheckQrSessionAttributes;
	};
}
